<div class="table-content-component-panel-monitoreo" style="position: relative;">

  <div
          class="d-flex flex-column justify-content-center align-items-center"
          style="position: absolute;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.8);
          z-index: 999999;"
          *ngIf="isUnderConstruction">
          <img
              src="./assets/images/en_construccion.png"
              alt="under_construction"
              style="display: flex; max-width: 50%; max-height: 20rem; margin-bottom: 1rem;">
          <span style="color: #fff;">{{'SUBACCOUNTS.CONSTRUCTION_PANEL' | translate}}</span>
      </div>

      <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" name="loadingSubcuentas" size = "medium" color = "#fff" type = "ball-pulse" [fullScreen] = "false"><p style="color: white" class="text-center"> {{'COMMON.LOADING_INF' | translate}}</p></ngx-spinner>

      <div class="panel-izq-table-container" style="flex-grow: 0;">
        <table id="tbl_geos">
          <colgroup>
            <col width="15%" />
            <col width="25%" />
            <col width="30%" />
            <col width="15%" />
            <col width="15%" />

          </colgroup>
          <thead class="visible-on-scroll">
              <tr>
                  <th>Nº</th>
                  <th class="text-start">{{'FIELDS.NAME' | translate}}</th>
                  <th class="text-start">{{'FIELDS.EMAIL' | translate}}</th>
                  <th>{{'FIELDS.ACTIVE' | translate}}</th>
                  <th><i class="fa fa-pencil fa-lg"></i></th>

              </tr>
          </thead>
          <tbody style="border-top: inherit;">

              <tr *ngFor="let sub of subcuentasService.tblDataSubUser;let indice=index">
                <td class="text-center">{{indice+1}} </td>
                <td>{{sub.trama.nombre_usuario}} </td>
                <td>{{sub.trama.email}}</td>

                <td class="inline-png-checkbox text-center">
                  <p-checkbox [(ngModel)]="sub.trama.activo" [disabled]="true" [binary]="true"></p-checkbox>
                </td>


                <td>
                  <div *appHasPermission="['subaccounts_enabledisable', 'subaccounts_update', 'subaccounts_delete']" ngbDropdown container="body" class="d-flex justify-content-center align-items-center edit-column" [autoClose]="true" placement="right-top right-bottom left-top left-bottom">

                    <i class="fa fa-pencil" ngbDropdownToggle></i>
                    <div ngbDropdownMenu class="gl-custom-dropdown geofences-table-dropdown">
                      <div *appHasPermission="'subaccounts_enabledisable'" ngbDropdownItem (click)="clickActivarSubusuario(sub.trama.id)" ><i class="fa fa-pencil-square-o" aria-hidden="true"></i>{{'GENERAL.ACTIVE' | translate}}/{{'GENERAL.DEACTIVATE' | translate}}</div>
                      <div *appHasPermission="'subaccounts_update'" ngbDropdownItem (click)="clickConfigurarSubusuario(sub.trama.id)" ><i class="fa fa-pencil-square-o" aria-hidden="true"></i>{{'GENERAL.CONFIGURE' | translate}}</div>
                      <div *appHasPermission="'subaccounts_delete'" ngbDropdownItem (click)="clickEliminarSubusuario($event, sub.trama.id)" ><i class="fa fa-trash-o" aria-hidden="true"></i> {{'GENERAL.DELETE' | translate}}</div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="subcuentasService.isRowDataEmpty">
                <td colspan="6" class="text-center">{{'SUBACCOUNTS.NO_SUBACCOUNTS_CONFIGURED' | translate}}</td>
              </tr>

          </tbody>
        </table>
      </div>

      <div *appHasPermission="'subaccounts_create'" class="d-flex justify-content-center my-4 panel-izq-container-footer">
        <div class="col-6">
            <button type="button" (click)="clickAgregarSubusuario()" class="btn-gl-save btn-dark-hover w-100" ui-sref="alertas-accesorios" >{{'SUBACCOUNTS.CREATE_NEW_SUBACCOUNT' | translate}}</button>
            <!-- <button type="button" (click)="sss()" class="btn-gl-save btn-dark-hover w-100" ui-sref="alertas-accesorios" >Crear nueva Subcuenta</button> -->
        </div>
      </div>

      <ng-container *appHasPermission="['subaccounts_create', 'subaccounts_update']">
      <div *ngIf="(subcuentasService.modalActive)">
        <app-subcuentas-modal></app-subcuentas-modal>
      </div>
    </ng-container>

</div>
